import { mailStore } from 'owa-mail-store';
import updateTodayDate from '../actions/updateTodayDate';
import { now } from 'owa-datetime/lib/displaydate/now';
var TIMER_DELAY = 30 * 1000; // we delay by 30 seconds the timer to fire and update the today date.
/**
 * Perform the tasks that are based on the date roll over
 */
export default function performDateTimeChangeTasks() {
    // Update today date
    updateTodayDate();
    // Schedule the date roll over task
    scheduleDateRollOverTask();
}
/**
 * Schedule the date roll over task
 */
function scheduleDateRollOverTask() {
    var tomorrow = new Date(mailStore.todayDate);
    tomorrow.setDate(tomorrow.getDate() + 1);
    // When the day changes, update the store value.
    setTimeout(performDateTimeChangeTasks, tomorrow.getTime() - now().getTime() + TIMER_DELAY);
}
//# sourceMappingURL=performDateTimeChangeTasks.js.map